// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.mdoc.transport

import org.multipaz.cbor.DataItem
import org.multipaz.mdoc.transport.NfcHybridTransportStats
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.toDataItem

fun NfcHybridTransportStats.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "n0huHNPJVwnDHXisQIE4mBzEDJDPPJX34343MWGr_CU")
val NfcHybridTransportStats_cborSchemaId = ByteString(-97, 72, 110, 28, -45, -55, 87, 9, -61, 29, 120, -84, 64, -127, 56, -104, 28, -60, 12, -112, -49, 60, -107, -9, -29, 126, 55, 49, 97, -85, -4, 37)

fun NfcHybridTransportStats.Companion.fromCbor(data: ByteArray): NfcHybridTransportStats {
    return NfcHybridTransportStats.fromDataItem(Cbor.decode(data))
}

val NfcHybridTransportStats.Companion.cborSchemaId: ByteString
    get() = NfcHybridTransportStats_cborSchemaId

fun NfcHybridTransportStats.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("numSent", this.numSent.toLong().toDataItem())
    builder.put("numSentViaNfc", this.numSentViaNfc.toLong().toDataItem())
    builder.put("numSentViaTransport", this.numSentViaTransport.toLong().toDataItem())
    builder.put("numReceived", this.numReceived.toLong().toDataItem())
    builder.put("numReceivedFirstOnNfc", this.numReceivedFirstOnNfc.toLong().toDataItem())
    builder.put("numReceivedFirstOnTransport", this.numReceivedFirstOnTransport.toLong().toDataItem())
    builder.put("nfcDisconnectedDuringTransaction", this.nfcDisconnectedDuringTransaction.toDataItem())
    return builder.end().build()
}

fun NfcHybridTransportStats.Companion.fromDataItem(dataItem: DataItem): NfcHybridTransportStats {
    val numSent = dataItem["numSent"].asNumber.toInt()
    val numSentViaNfc = dataItem["numSentViaNfc"].asNumber.toInt()
    val numSentViaTransport = dataItem["numSentViaTransport"].asNumber.toInt()
    val numReceived = dataItem["numReceived"].asNumber.toInt()
    val numReceivedFirstOnNfc = dataItem["numReceivedFirstOnNfc"].asNumber.toInt()
    val numReceivedFirstOnTransport = dataItem["numReceivedFirstOnTransport"].asNumber.toInt()
    val nfcDisconnectedDuringTransaction = dataItem["nfcDisconnectedDuringTransaction"].asBoolean
    return NfcHybridTransportStats(
        numSent = numSent,
        numSentViaNfc = numSentViaNfc,
        numSentViaTransport = numSentViaTransport,
        numReceived = numReceived,
        numReceivedFirstOnNfc = numReceivedFirstOnNfc,
        numReceivedFirstOnTransport = numReceivedFirstOnTransport,
        nfcDisconnectedDuringTransaction = nfcDisconnectedDuringTransaction,
    )
}
